import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
}

export const KnappPilHøyre: React.FC<SvgProps> = ({ pathFill = '#ECECEC', ...props }) => (
	<svg
		width='100%'
		height='100%'
		viewBox='0 0 17 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<g id='Ikoner/Chevron-right'>
			<path
				id='Vector'
				d='M12.8524 7.36777C13.2006 7.71595 13.2006 8.27896 12.8524 8.62344L5.74072 15.7389C5.39254 16.087 4.82953 16.087 4.48505 15.7389C4.14058 15.3907 4.13687 14.8277 4.48505 14.4832L10.9671 8.00116L4.48135 1.51541C4.13317 1.16723 4.13317 0.604221 4.48135 0.259747C4.82953 -0.0847277 5.39254 -0.0884317 5.73701 0.259747L12.8524 7.36777Z'
				fill='#697277'
			/>
		</g>
	</svg>
);
